import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const LIST_DATASETS = registerQuery({
  fieldName: 'listDatasets',
  fetcher: () => {
    return http.get('sql-reporting/v1/datasets');
  }
});